import { FormEvent, PropsWithChildren, RefObject } from 'react';

import { Form } from '@eneco/sparky';
import { FormProps } from '@eneco/sparky/types';
import { FieldValues, SubmitHandler, useFormContext } from 'react-hook-form';

import { RecaptchaRef } from '../Recaptcha/Recaptcha';

export type RecaptchaFormProps<T extends FieldValues> = Omit<FormProps, 'onSubmit'> & {
  onSubmit: SubmitHandler<T>;
  recaptchaRef: RefObject<RecaptchaRef>;
};

export const RecaptchaForm = <T extends FieldValues>({
  children,
  onSubmit,
  recaptchaRef,
  ...rest
}: PropsWithChildren<RecaptchaFormProps<T>>) => {
  const methods = useFormContext();

  if (methods === null) {
    throw new Error(`RecaptchaForm must be used within a FormProvider`);
  }

  const { handleSubmit, setValue } = methods;

  const submitForm = async (event: FormEvent) => {
    event.preventDefault();
    setValue('recaptchaToken', await recaptchaRef.current?.verify());
    return handleSubmit((data: FieldValues) => onSubmit(data as T))();
  };

  return (
    <Form onSubmit={submitForm} {...rest}>
      {children}
    </Form>
  );
};
